import script from "./RegionSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegionSelector.vue?vue&type=script&setup=true&lang=ts"

import "./RegionSelector.vue?vue&type=style&index=0&id=841dc366&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-841dc366"]])

export default __exports__